export const BORDER_COLORS = {
  PRIMARY: '#004d40',
  SECONDARY: '#216e54',
  SUCCESS: '#007500',
  WARNING: '#c48e00',
  DANGER: '#b8000e',
  LIGHT: '#d9d4d1',
  DARK: '#726c68',
} as const;
